import React from 'react';
import { _ } from '@hugendubel/utils';
import { ReducedProductAvailability } from '../../../ws/result/ReducedProduct';

export type OnlineAvailabilityProps = { availabilityData: ReducedProductAvailability };

export const OnlineAvailability: React.FC<OnlineAvailabilityProps> = ({
    availabilityData: { currentlyAvailable, text },
}) => (
    <div className="item-availability">
        <div className={_.classNames('availability', currentlyAvailable && 'immediately')}>{text}</div>
    </div>
);
